// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonsNavs_onFfY {
	display: inline-flex;
	align-items: center;
	gap: 5px;

	button {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 32px;
		height: 32px;
		border-radius: 4px;
		border: none;
		background: transparent;
		color: var(--_16c098-background);
		cursor: pointer;

		svg {
			min-width: 26px;
			min-height: 26px;
			color: var(--black-color);
			fill: transparent;
			width: 26px;
		}

		&:hover {
			color: var(--_16c098-background);
		}
	}
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/NavArrowButtons.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;;CAER;EACC,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;;EAEf;GACC,eAAe;GACf,gBAAgB;GAChB,yBAAyB;GACzB,iBAAiB;GACjB,WAAW;EACZ;;EAEA;GACC,gCAAgC;EACjC;CACD;AACD","sourcesContent":[".buttonsNavs {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 5px;\n\n\tbutton {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tborder-radius: 4px;\n\t\tborder: none;\n\t\tbackground: transparent;\n\t\tcolor: var(--_16c098-background);\n\t\tcursor: pointer;\n\n\t\tsvg {\n\t\t\tmin-width: 26px;\n\t\t\tmin-height: 26px;\n\t\t\tcolor: var(--black-color);\n\t\t\tfill: transparent;\n\t\t\twidth: 26px;\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: var(--_16c098-background);\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonsNavs": `buttonsNavs_onFfY`
};
export default ___CSS_LOADER_EXPORT___;
